import { Plus } from "lucide-react";
import type { Workspace } from "@/api/types";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { AssistantButton } from "@/features/assistant/AssistantProvider";
import { useOpenNewEntry } from "./NewEntry";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";

/** Topo da área de conteúdo. Celular: logotipo + workspace. Tablet: workspace + ação principal. Desktop: ação principal. */
export function TopBar({
  mobile,
  compactNav,
  workspace,
  workspaces,
  canWrite,
}: {
  mobile: boolean;
  /** Lateral recolhida (tablet): o seletor de workspace vem para o topo. */
  compactNav: boolean;
  workspace: Workspace;
  workspaces: Workspace[];
  canWrite: boolean;
}) {
  const newEntry = useOpenNewEntry();
  if (mobile)
    return (
      <header className="flex items-center gap-3 pt-[calc(env(safe-area-inset-top)_+_1rem)] pr-[calc(env(safe-area-inset-right)_+_1rem)] pb-2 pl-[calc(env(safe-area-inset-left)_+_1rem)]">
        <Logo compact />
        <WorkspaceSwitcher current={workspace} workspaces={workspaces} bare />
        <div className="ml-auto">
          <AssistantButton compact />
        </div>
      </header>
    );
  return (
    <header className="flex min-h-11 items-center justify-end gap-3">
      {compactNav && (
        <div className="mr-auto min-w-0">
          <WorkspaceSwitcher current={workspace} workspaces={workspaces} bare />
        </div>
      )}
      <AssistantButton />
      {canWrite && (
        <Button {...newEntry.triggerProps} onClick={newEntry.open}>
          <Plus aria-hidden="true" className="size-[18px]" strokeWidth={2.4} />
          Novo lançamento
        </Button>
      )}
    </header>
  );
}
